import LayoutGuest from '../../components/layouts/LayoutGuest';
import AllService from './List';

export default function PagePromo() {
  return (
    <LayoutGuest className="max-w-screen-xl">
      <AllService />
    </LayoutGuest>
  );
}
